import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/(marketing)/home-content.tsx");
